import LegalLayout from "@/components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      testid="privacy-policy-page"
      title="Privacy Policy"
      lastUpdated="February 2026"
    >
      <p>
        Brand-in-a-Box ("we", "us", "our") respects your privacy. This Privacy
        Policy explains how we collect, use, disclose, and safeguard your
        information when you visit our website or engage our services. This
        policy is intended to comply with the EU General Data Protection
        Regulation (GDPR), the UK GDPR, and the California Consumer Privacy Act
        (CCPA).
      </p>

      <h2>1. Information We Collect</h2>
      <p>We collect the following categories of information:</p>
      <ul>
        <li>
          <strong>Contact information</strong> you voluntarily provide via the
          intake form, contact form, or email correspondence — including name,
          email address, company name, role, website, and project details.
        </li>
        <li>
          <strong>Cookie and usage data</strong> collected automatically when
          you visit the site, including IP address, browser type, pages viewed,
          and referring URL.
        </li>
        <li>
          <strong>Communication records</strong> when you contact us, including
          email threads, project briefs, and feedback.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To respond to proposal requests and prepare custom proposals.</li>
        <li>To deliver and manage branding engagements.</li>
        <li>To issue invoices and process payments.</li>
        <li>To send service-related communications.</li>
        <li>
          To send marketing communications, only where you have provided
          explicit consent.
        </li>
        <li>To improve our website performance and user experience.</li>
      </ul>

      <h2>3. Legal Basis for Processing (GDPR / UK GDPR)</h2>
      <p>
        We process your personal data under one or more of the following legal
        bases: contract performance, legitimate interests, legal compliance,
        and consent.
      </p>

      <h2>4. Cookies</h2>
      <p>
        We use essential, analytics, marketing, and preference cookies. You can
        manage your preferences at any time via the cookie banner or by
        visiting our <a href="/cookie-policy">Cookie Policy</a>.
      </p>

      <h2>5. Analytics</h2>
      <p>
        We may use privacy-respecting analytics providers to understand
        aggregate usage. Analytics cookies are only set after you grant
        consent.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        We retain personal data only for as long as necessary to fulfil the
        purposes outlined in this policy, comply with legal obligations,
        resolve disputes, and enforce agreements. Submission records are
        retained for up to 36 months unless a longer period is required by
        law.
      </p>

      <h2>7. Third-Party Services</h2>
      <p>
        We may share information with vetted third-party providers strictly to
        operate our business — for example, payment processors, email
        providers, and hosting providers. These providers process information
        only on our behalf and are bound by data protection obligations.
      </p>

      <h2>8. International Transfers</h2>
      <p>
        Where personal data is transferred outside the EEA/UK, we ensure
        appropriate safeguards are in place, such as Standard Contractual
        Clauses.
      </p>

      <h2>9. Your Rights</h2>
      <p>
        Subject to applicable law, you have the right to access, rectify,
        erase, restrict, or object to the processing of your personal data,
        and the right to data portability. California residents have specific
        rights under the CCPA, including the right to know, delete, and
        opt-out of the "sale" of personal information. We do not sell personal
        information.
      </p>

      <h2>10. Security</h2>
      <p>
        We implement reasonable administrative, technical, and physical
        safeguards to protect your information. However, no method of
        transmission over the internet is fully secure.
      </p>

      <h2>11. Children's Privacy</h2>
      <p>
        Our services are not directed to individuals under the age of 16. We
        do not knowingly collect personal data from children.
      </p>

      <h2>12. Changes</h2>
      <p>
        We may update this policy from time to time. The "Last updated" date
        will reflect any changes.
      </p>

      <h2>13. Contact</h2>
      <p>
        For privacy-related requests, contact{" "}
        <a href="mailto:hello@bigeyedeassystems.com">hello@bigeyedeassystems.com</a>.
      </p>
    </LegalLayout>
  );
}
